<template>
  <el-popover
    placement="bottom"
    width="210"
    trigger="click"
    popper-class="patient-poper"
    v-model="visible"
  >
    <div>
      <el-input
        v-model="keywords"
        size="mini"
        class="search-input"
        placeholder="search"
      ></el-input>
      <img
        class="search-icon"
        src="../assets/search-list.svg"
        @click="search"
      />
      <div class="patient-item-wrapper" v-if="pods.length">
        <div
          class="patient-item"
          v-for="(pod, index) in pods"
          :key="index"
          @click="selectPod(pod)"
        >
          <div>
            <img
              class="circle-img mr-20"
              :src="pod.avatarUrl"
              v-if="pod.avatarUrl"
            />
            <div v-else class="mr-20 grey-circle v-h-center">
              <img src="../assets/picture_white.svg" />
            </div>
          </div>
          <div>
            <div class="name">
              {{ pod.podId ? pod.podId.substring(pod.podId.length - 5) : '' }}
            </div>
            <div class="desc">
              <div>{{ pod.podId }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data text-center" v-else></div>
    </div>
    <div class="patient-input-wrapper inline-block" slot="reference">
      <div class="patient-input" prop="patient">
        <i
          class="el-icon-close"
          v-if="!globalSync"
          @click.stop="clearPod()"
        ></i>
        <img
          class="circle-img mr-20"
          :src="pod.avatarUrl"
          v-if="pod.avatarUrl"
        />
        <div v-else class="mr-20 white-circle v-h-center">
          <img src="../assets/picture_grey.svg" />
        </div>
        <div>
          <div class="name">
            {{ pod.podId ? pod.podId.substring(pod.podId.length - 5) : '' }}
          </div>
          <div class="desc">
            <div>{{ pod.podId }}</div>
          </div>
        </div>
        <img
          class="arrow"
          :class="visible ? 'rotate-180' : ''"
          src="../assets/arrow-down.svg"
        />
      </div>
    </div>
  </el-popover>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      visible: false,
      keywords: '',
      pod: '',
      pods: this.$store.state.pods.pods,
      keywordsTimer: ''
    }
  },
  props: {
    globalSync: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mounted() {
    this.$store.dispatch('pods/fetchPods').then(() => {
      this.pods = this.$store.state.pods.pods
      if (this.globalSync) {
        this.pod = this.$store.state.pods.selectedPod
      }
    })
  },
  watch: {
    keywords() {
      if (this.keywordsTimer) {
        clearTimeout(this.keywordsTimer)
      }
      this.keywordsTimer = setTimeout(this.search, 500)
    },
    '$store.state.pods.selectedPod': function() {
      this.pod = this.$store.state.pods.selectedPod
    },
    pod() {
      if (!this.globalSync) {
        this.$emit('updateData')
      }
    }
  },
  methods: {
    search() {
      return ApiService.GetConfiguration()
        .then(response => {
          this.pods = response.data.pods
          if (this.keywords) {
            this.pods = this.pods.filter(item => {
              return (
                item.podId.toLowerCase().indexOf(this.keywords.toLowerCase()) >
                -1
              )
            })
          }
        })
        .catch(() => {})
    },
    selectPod(item) {
      this.pod = item
      this.visible = false
      if (this.globalSync) {
        this.$store.commit('pods/SET_SELECTED_POD', this.pod)
      }
    },
    clearPod() {
      this.pod = ''
    }
  },
  beforeDestroy() {
    clearInterval(this.keywordsTimer)
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  height: 80px;
}
</style>
